import {NgModule} from '@angular/core';
import {PullTabComponent} from './pull-tab.component';

@NgModule({
  declarations: [PullTabComponent],
  exports: [PullTabComponent],
})
export class PullTabModule {}
